/* global axios */
import ApiClient from '../ApiClient';

class AddonsAPI extends ApiClient {
  constructor() {
    super('omni/addons', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/omni/addons
  getAll() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:account_id/omni/addons/active
  getActive() {
    return axios.get(`${this.url}/active`);
  }

  // POST /api/v1/accounts/:account_id/omni/addons/:id/checkout
  createCheckout(addonId, billingCycle = 'monthly', quantity = 1, successUrl = null, cancelUrl = null) {
    const params = { billing_cycle: billingCycle, quantity };
    if (successUrl) params.success_url = successUrl;
    if (cancelUrl) params.cancel_url = cancelUrl;

    return axios.post(`${this.url}/${addonId}/checkout`, params);
  }

  // DELETE /api/v1/accounts/:account_id/omni/addons/:id/cancel
  // DEPRECATED: Use cancelSubscriptionById instead for better control
  cancelSubscription(addonId, atPeriodEnd = true) {
    return axios.delete(`${this.url}/${addonId}/cancel`, {
      data: { at_period_end: atPeriodEnd },
    });
  }

  // DELETE /api/v1/accounts/:account_id/omni/addons/subscriptions/:subscription_id
  // Cancel a specific subscription by its ID (recommended for multiple subscriptions)
  cancelSubscriptionById(subscriptionId, atPeriodEnd = true) {
    return axios.delete(`${this.url}/subscriptions/${subscriptionId}`, {
      data: { at_period_end: atPeriodEnd },
    });
  }
}

export default new AddonsAPI();
